import { gql } from "@apollo/client";

const WAITLIST_NOMINATION = gql`
mutation WaitlistNomination($id: String){
    waitlistNomination(id: $id)
    }
`;

export default WAITLIST_NOMINATION;
